import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D996574D-5B42-47C5-91D6-F86555C2FBC5
 * name chart-line
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line.svg
 * tags
 * - Math 
 */
export const ChartLineIcon = createSvgIcon(<><path d="M16,11.78L20.24,4.45L21.97,5.45L16.74,14.5L10.23,10.75L5.46,19H22V21H2V3H4V17.54L9.5,8L16,11.78Z" /></>, 'ChartLineIcon');
export default ChartLineIcon